import React, { useEffect, useState } from "react";
import axios from 'axios';
import Backdrop from '@material-ui/core/Backdrop';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import { useParams } from "react-router-dom";
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import Invoice from "./reports/Invoice";
import { injectIntl } from 'react-intl'
import { Container } from "@material-ui/core";
import { apiUrl } from "./vars";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  padding: {
    paddingTop: '20px'
  },
  right: {
    textAlign: 'right',
    marginTop: '20px',
    display: 'inline-block',
  }
}));

const QuoteDetail = (props) => {
  const classes = useStyles();
  const { id } = useParams();
  const [invoice, setInvoice] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios.post(`${apiUrl}/collections/get/${localStorage.client}_quote?token=${localStorage.token}`, { filter: { _id: id } })
      // axios.post(`${apiUrl}/collections/get/${localStorage.client}_quote?token=${localStorage.token}`, {})
      .then((response) => {
        const { entries } = response.data;

        setInvoice([entries[0]]);
        setIsLoading(false);
      })
      .catch(function (error) {
        // localStorage.clear();
        console.log(error);
      });
  }, []);

  if (isLoading) {
    return (
      <Backdrop className={classes.backdrop} open={true}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  };

  const translations = {
    description: 'Description',
    unite: 'Unité',
    quantite: 'Quantité',
    coutUnitaire: 'Coût unitaire',
    montant: 'Montant',
    type: 'Devis',
  }

  return (
    <div style={{ marginTop: '25px' }}>
      <Container fixed style={{ textAlign: 'center', marginBottom: 20 }}>
        <PDFDownloadLink document={<Invoice invoice={invoice} translations={translations} intl={props.intl} />} fileName={`${invoice.length === 1 ? invoice[0].invoice : 'Fature'}.pdf`}>
          {({ blob, url, loading, error }) => (loading ? 'Chargement du document ...' : <Button variant="contained" color="primary">Télécharger le document PDF</Button>)}
        </PDFDownloadLink>
      </Container>
      <PDFViewer width="950" height="1200" className="pdf-viewer" >
        <Invoice invoice={invoice} translations={translations} intl={props.intl} />
      </PDFViewer>
    </div>
  );
}

export default injectIntl(QuoteDetail);
